import React from "react";
import { Navigate } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { message } from "antd";

import { useAuth } from "../../helpers/auth";
import { signInPath } from "../../helpers/paths";

export function SignOut({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  const client = useApolloClient();

  const handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    client.resetStore();
    auth.clearSession();
    message.success("Logout sucessful!");
  };

  if (!auth.authenticated) {
    return <Navigate to={signInPath()} />;
  }

  return (
    <a href="/" onClick={handleClick}>
      {children}
    </a>
  );
}
